import React, { useEffect, useState } from "react";
import Heading from "../../shared/components/UIElements/Heading";
import { useUser } from "@clerk/clerk-react";
import {
	CheckCircleIcon,
	XMarkIcon,
	CheckIcon,
	ShieldCheckIcon,
} from "@heroicons/react/16/solid";
import { useSearchParams } from "react-router-dom";
import UpgradeToYearly from "../components/UpgradeToYearly";
import InvoicesList from "../components/settings/InvoicesList";
import CurrentPaymentMethod from "../components/settings/CurrentPaymentMethod";
import CancelSubscription from "../components/settings/CancelSubscription";
import useApi from "../../shared/hooks/useApi";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";

const SubscriptionSettings = () => {
	const { user } = useUser();

	const [status, setStatus] = useState(null);
	const { data: summary } = useApi(
		user?.id ? `/api/billing/settings/payment-method/${user.id}` : null,
	);

	const [searchParams] = useSearchParams();

	// Keep minimal existing status banner behavior

	useEffect(() => {
		if (searchParams.get("fromStripe") === "true") {
			setStatus(
				searchParams.get("succeeded") === "false" ? "error" : "success",
			);
		}
	}, [searchParams]);

	return (
		<div className="min-h-[85dvh] flex flex-col">
			<div className="flex items-center gap-3">
				<h1 className="text-2xl font-bold">Beheer je abonnement</h1>
				<span className="bg-green-100 text-green-700  border-green-700/60 bg-opacity-70  border-[0.8px] border-opacity-60 px-2 py-1 rounded-lg flex items-center gap-x-1 text-xs font-medium">
					<ShieldCheckIcon className="size-4" />
					Actief abonnement
				</span>
			</div>
			<div className="mt-1">
				{summary?.subscriptionStart ? (
					<p className="text-sm text-slate-600">
						Je maakt gebruik van DentHR sinds{" "}
						{new Date(
							summary.subscriptionStart * 1000,
						).toLocaleDateString("nl-NL", {
							day: "numeric",
							month: "long",
							year: "numeric",
						})}
					</p>
				) : (
					<LoadingSpinner />
				)}
			</div>

			{/* Encourage yearly upgrade prominently */}
			<div className="mt-6">
				<UpgradeToYearly />
			</div>

			{status === "success" && (
				<div className="flex items-center gap-2 bg-green-50 w-fit py-2 px-4 rounded-lg text-sm text-green-900 border-green-100 border mt-10">
					<CheckCircleIcon className="size-4 text-green-600" />
					<p>Je betaalmethode is gewijzigd.</p>
				</div>
			)}

			{status === "error" && (
				<div className="flex items-center gap-2 bg-red-50 w-fit py-2 px-4 rounded-lg text-sm text-red-900 border-red-100 border mt-10">
					<XMarkIcon className="size-5 text-red-600" />
					<p>
						Er is iets misgegaan bij het wijzigen van de
						betaalmethode. Probeer het opnieuw en neem anders
						contact met ons op via de chat
					</p>
				</div>
			)}

			<div className="flex flex-col gap-6 mt-6 flex-1">
				<div className="border-b border-slate-200 pb-12 mb-6">
					<CurrentPaymentMethod />
				</div>
				<div>
					<InvoicesList />
				</div>
			</div>
			<div className="mt-8">
				<CancelSubscription />
			</div>
		</div>
	);
};

export default SubscriptionSettings;
